import './PricingRequestForm.css';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import InfoBox from '../components/InfoBox';
import clearFacet from '../actions/clear_facet';
import clearProducts from '../actions/clear_products';
import LoadingIndicator from '../components/LoadingIndicator';
import { withRouter } from 'react-router-dom';
import SelectionResult from '../components/SelectionResult';
import CustomerDataInput from '../components/CustomerDataInput';
import sendPricingRequest from '../actions/send_pricing_request';
import { Translate } from 'react-localize-redux';
import { getTranslate, withLocalize } from 'react-localize-redux/lib/index';
import { detect } from 'detect-browser';

class PricingRequestForm extends Component {
  constructor(props) {
    super(props);

    this.executePricingRequest = this.executePricingRequest.bind(this);

    this.resizeFrameToFit = this.resizeFrameToFit.bind(this);
    this.scrollFrameToInitial = this.scrollFrameToInitial.bind(this);

    const browser = detect();
    this.state = {
      browser: browser
    };
  }

  componentDidMount() {
    this.resizeFrameToFit();
    this.scrollFrameToInitial();
  }

  resizeFrameToFit() {
    if ('parentIFrame' in window) {
      var scrollHeight = document.getElementById('root').scrollHeight;
      console.log('Resizing to ' + scrollHeight);
      //window.parentIFrame.size(scrollHeight);
    }
  }

  scrollFrameToInitial() {
    if ('parentIFrame' in window) {
      console.log('Scrolling to Frame');
      window.parentIFrame.scrollToOffset(0, 0);
    }
  }

  executePricingRequest(customerData) {
    var dto = {};
    dto.to = this.props.shopParameters.partnerEmail;
    dto.subject =
      'Spannbacken-Finder ' +
      this.props.translate('PricingRequestForm_PriceInquiry');
    dto.body = {};
    dto.body.customer = customerData;
    dto.body.categories = this.props.selectedProducts;
    dto.body.locale = this.props.locale;

    this.props.sendPricingRequest(dto);
  }

  componentWillReceiveProps(nextProps) {
    // this check makes sure that the getDashboardStats action is not getting called for other prop changes
    if (this.props.sendingSucceeded !== nextProps.sendingSucceeded) {
      if (nextProps.sendingSucceeded) {
        this.props.history.push('/requestSent');
      }
    }
  }

  render() {
    return (
      <div className="row">
        <div className="col-12 col-sm-8">
          <div className="divider" />
          <h3>
            <Translate id="PricingRequestForm_PriceInquiry" />
          </h3>

          <div className="row">
            {this.props.isFetching ? <LoadingIndicator /> : <span />}
          </div>

          <div className="col-12 col-sm-12">
            <CustomerDataInput
              executePricingRequest={this.executePricingRequest}
              shopParameters={this.props.shopParameters}
            />
          </div>

          <div className="divider" />
        </div>
        {(this.state.browser === undefined ||
          !(
            this.state.browser.version !== undefined &&
            this.state.browser.version.length > 0 &&
            this.state.browser.version[0] === '9' &&
            this.state.browser.name === 'ie'
          )) && (
          <div className="col-12 col-sm-4">
            <InfoBox
              heading={'InfoBox_Header'}
              text={'InfoBox_Text'}
              phone={this.props.partnerPhoneNumber}
              serviceHoursLine1={this.props.partnerServiceHoursLine1}
              serviceHoursLine2={this.props.partnerServiceHoursLine2}
            />
          </div>
        )}
        <div className="col-12 col-sm-12">
          <h3 className="text-brand">
            <Translate id="PricingRequestForm_PriceInquiryQuote" />
          </h3>
          <SelectionResult data={this.props.selectedProducts} />
        </div>
      </div>
    );
  }
}

function mapStateToProps({
  products,
  shopParameters,
  pricingRequest,
  localize
}) {
  return {
    selectedProducts: products.selected,

    isFetching: pricingRequest.isFetching,
    sendingSucceeded: pricingRequest.sendingSucceeded,

    shopParameters: shopParameters.data,

    partnerPhoneNumber: shopParameters.data.partnerServiceNumber,
    partnerServiceHoursLine1: shopParameters.data.serviceHoursLine1,
    partnerServiceHoursLine2: shopParameters.data.serviceHoursLine2,

    locale: shopParameters.data.locale,
    translate: getTranslate(localize)
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      clearFacet,
      clearProducts,
      sendPricingRequest
    },
    dispatch
  );
}

export default withLocalize(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(PricingRequestForm))
);



// WEBPACK FOOTER //
// ./src/containers/PricingRequestForm.js